import w from "./index.es500.js";
import v from "./index.es501.js";
import C from "./index.es502.js";
import S from "./index.es503.js";
import k from "./index.es504.js";
import D from "./index.es505.js";
import E from "./index.es506.js";
var A = `<?xml version="1.0" ?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:mv="urn:schemas-microsoft-com:mac:vml" xmlns:mx="http://schemas.microsoft.com/office/mac/excel/2008/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns:xm="http://schemas.microsoft.com/office/excel/2006/main">{views}{columnsDescription}<sheetData>{data}</sheetData>{mergedCellsDescription}{layout}{drawing}</worksheet>`;
function $(r, e) {
  var t = e.schema, s = e.columns, a = e.images, m = e.getHeaderStyle, i = e.getStyle, c = e.getSharedString, n = e.customFont, l = e.dateFormat, h = e.orientation, p = e.stickyRowsCount, f = e.stickyColumnsCount, d = e.showGridLines, y = e.rightToLeft, g = e.sheetId;
  T(r, {
    schema: t
  });
  var o = C(r, {
    schema: t
  }), x = o.data, u = o.mergedCells;
  return A.replace("{data}", w(x, {
    schema: t,
    getHeaderStyle: m,
    getStyle: i,
    getSharedString: c,
    customFont: n,
    dateFormat: l
  })).replace("{views}", D({
    stickyRowsCount: p,
    stickyColumnsCount: f,
    showGridLines: d,
    rightToLeft: y
  })).replace("{columnsDescription}", v({
    schema: t,
    columns: s
  })).replace("{mergedCellsDescription}", S(u)).replace("{layout}", k({
    sheetId: g,
    orientation: h
  })).replace("{drawing}", E({
    images: a
  }));
}
function T(r, e) {
  var t = e.schema;
  if (t) {
    if (!Array.isArray(r))
      throw new TypeError("Expected an array of objects");
  } else {
    if (!Array.isArray(r))
      throw new TypeError("Expected an array of arrays");
    if (r.length > 0 && !Array.isArray(r[0]))
      throw new TypeError("Expected an array of arrays");
  }
}
export {
  $ as default
};
//# sourceMappingURL=index.es476.js.map
